import styled from "styled-components";

interface WrapperProps {
  $disabled: boolean;
  $labelColor: string;
  $height?: string;
  $width?: string;
  $paddingForPrefix?: string;
  $isReadonly?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
  border: 1px solid;
  border-color: ${(props: {
    $disabled: boolean;
    $labelColor: string;
    $height?: string;
    $width?: string;
    $paddingForPrefix?: string;
  }) => (props.$disabled ? "#ececec" : "#E9E9E9")};
  border-radius: 8px;
  height: ${(props) => props.$height ?? "48px"};
  width: ${(props) => props.$width ?? ""};

  &:hover {
    border-color:${(props) => props.$isReadonly ? '#E9E9E9' : '#a3a3a3'};
  }

  &:focus-within {
    border: 1px solid ${(props) => props.$isReadonly ? '#E9E9E9' : '#000000'};
  }

  &.password_success_style {
    border: 1px solid #a3a3a3;
  }

  &.is-tooltip-field + .tooltip-container {
    display: none;
  }
  &.is-tooltip-field.has-focus + .tooltip-container {
    display: block;
  }
  &.error,
  &.password_error_style {
    border: 1px solid #f9123b;
  }
  &.error p,
  &.password_error_style p {
    color: #f9123b;
  }

  & p {
    height: 100%;
    display: flex;
    align-items: center;
    background-color: ${(props) => props.$labelColor || "#fff"};
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1),
      opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);
    @media (max-width: 375px) {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: max-content
    }
    &.input-label {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #8D8D8D;
      position: absolute;
      top: 0px;
      left: 14px;
      margin: 0;
      padding: 0;
      &.has-value {
        z-index: -1;
      }
      &.top {
        height: max-content;
        font-size: 12px;
        line-height: 16px;
        color: #A3A3A3;
        transform: translate(-6px, -8px);
        padding: 0 2px;
        z-index: 0;
      }
    }
  }

  input {
    font-family: "Inter";
    padding: 12px 12px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    width: 100%;
    box-sizing: border-box;
    background-color: transparent;
    border: none;
    outline: none;
    color: ${(props) => (props.$disabled ? "#757575" : "none")};
    padding-left: ${(props: WrapperProps) => ( props.$paddingForPrefix )};
    cursor: ${(props) => props.$isReadonly ? 'default' : ''};

    &::placeholder {
      background-color: transparent;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #8D8D8D !important;
    }

    &::disabled {
      color: #a3a3a3 !important;
      background: red !important;
    }
  }
`;

export const ButtonWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: absolute;
  top: 2px;
  right: 5px;
  box-sizing: border-box;
  background-color: transparent;
  padding-bottom: 5px;

  svg {
    height: 20px;
  }
`;

interface Props {
  disabled: boolean;
}

export const InputContainer = styled.div<Props>`
  display: flex;
  font-size: 14px;
  line-height: 16px;
  align-items: center;
  position: relative;
  width: 100%;
  border-radius: 8px;
  height: 100%;
  & svg {
    margin-right: 10px;
  }
`;

export const CountryPhoneCode = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #E9E9E9;
`

export const tooltipInnerStyle = {fontSize: '14px', lineHeight: '16px'}